var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    className: "location_svg__ywnoU",
    viewBox: "0 0 32 32",
    "aria-hidden": "false"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 2.667c-6 0-10.667 4.4-10.667 10 0 7.2 7.6 14.4 10 16.4.4.36.934.36 1.334 0 2.4-2 10-9.2 10-16.4 0-5.6-4.667-10-10.667-10zm0 16c-2.933 0-5.333-2.4-5.333-5.334C10.667 10.4 13.067 8 16 8c2.933 0 5.333 2.4 5.333 5.333 0 2.934-2.4 5.334-5.333 5.334z"
  })));
}
export default SvgLocation;